import { render, staticRenderFns } from "./SiteNavDesktopV2SubNav.vue?vue&type=template&id=c380e82e&scoped=true&lang=pug"
import script from "./SiteNavDesktopV2SubNav.vue?vue&type=script&lang=js"
export * from "./SiteNavDesktopV2SubNav.vue?vue&type=script&lang=js"
import style0 from "./SiteNavDesktopV2SubNav.vue?vue&type=style&index=0&id=c380e82e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c380e82e",
  null
  
)

export default component.exports